import { useLang } from "@/lib/lang";
import { ZMark } from "@/components/ZMark";

export const Marquee = () => {
  const { t } = useLang();
  return (
    <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 py-10 sm:py-14">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {t.marquee.map((word, i) => (
              <span key={i} className="flex items-center">
                <span className={`whitespace-nowrap px-8 font-display text-5xl font-bold tracking-[-0.03em] sm:px-12 sm:text-7xl lg:text-8xl ${i % 2 ? "text-outline" : "text-white/90"}`}>
                  {word}
                </span>
                <ZMark id={`mq-${k}-${i}`} className="h-8 w-8 shrink-0 sm:h-12 sm:w-12" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
